<template>
<div class="paydetail" name="paydetail">
  <topNav :title="title"></topNav>
  <parkingpay></parkingpay>
</div>

</template>
<script>
import topNav from "../topnav/topnav"
import parkingpay from "../paydetail/parkingpay2"
export default {
  name: 'paydetail',
  components:{
     topNav,
     parkingpay
  },
  data() {
    return {
      title:"临时缴费"
    }
  },
  created(){
    //  this.$toast.loading({
    //     mask: true,
    //     message: '加载中...',
    //     duration:1000
    //     });
  }

}
</script>
<style>
.pay_btn {
    width: 92%;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    background-color: rgb(70,135,248);
    color: white;
    margin: 1.5rem auto;
    border-radius: 5px;
    font-size: 1.1rem;
    -webkit-box-shadow: 0.1rem 0.1rem 0.7rem #A3A3A3;
    box-shadow: 0rem 0.2em 0.8rem #5b82c18a;
}
.car_num{
  display: flex;
  background: white;

}
.car_num .img{
  width: 25%;
}
.car_num .num{
  width: 73%;
  text-align: right;
  padding-top: 28px;
  padding-right: 15px;
}
.car_num img{
  width: 100%
}
.pay_info,.total_fee{
  background-color: white;
  padding: 10px 0;
  margin-top: 8px;
}
.pay_info p,.total_fee p{
  margin: 8px 0;
}
.pay_info p span,.total_fee p span{
  display:inline-block;
}
.pay_info p .park_name,.total_fee p .park_name{
  width: 20%;
  text-align: left;
}
.pay_info p .park_value,.total_fee p .park_value{
  width: 73%;
  text-align: right;
}

</style>




// WEBPACK FOOTER //
// src/components/paydetail/paydetail.vue